import type { LineItemProduct } from '@weft/types';
import { isNotNullOrUndefined, isSingleItem } from '@weft/utils';

export function getProductTitle(lineItemProduct: LineItemProduct) {
  if (isNotNullOrUndefined(lineItemProduct.name)) {
    return lineItemProduct.name;
  }

  const [firstProductVariant] = lineItemProduct.variants;
  const firstProductVariantName = firstProductVariant.name;

  if (isSingleItem(lineItemProduct.variants)) {
    return firstProductVariantName;
  }

  return lineItemProduct.name ?? firstProductVariantName;
}